import React from "react";
import { Document, pdf } from "@react-pdf/renderer";
import { saveAs } from "file-saver";
import { IntroductionPage } from "./pages/IntroductionPage";
import { SalientFactsPage } from "./pages/SalientFactsPage";
import { MarketCapVacancyRentalRatePage } from "./pages/MarketCapVacancyRentalRatePage";
import { SalesComparablesPage } from "./pages/SalesComparablesPage";
import { PropertyImagesPage } from "./pages/PropertyImagesPage";
import { PropertyMailPage } from "./pages/PropertyMailPage";
import { IncomeAndExpenseProFormaPage } from "./pages/IncomeAndExpenseProFormaPage";
import { CostApproachPage } from "./pages/CostApproachPage";
import { AppealAttachmentsPage } from "./pages/AppealAttachmentsPage";
import { SalesCompsImagesPage } from "./pages/SalesCompsImagesPage";
import { IncomeCompsImagesPage } from "./pages/IncomeCompsImagesPage";
import { CostMVSImagesPage } from "./pages/CostMVSImagesPage";

const createFileName = () => {
    const timestamp = new Date().getTime();

    return `property-report-${timestamp}.pdf`;
};

const getConfidentialInfo = data => {
    const referenceNumber =
        data.appealApproachCalculationData.exportAppealsPackage.salientFacts.referenceNumber;

    return `${referenceNumber}    Confidential`;
};

const createPdfDocument = async (data, confidentialInfo, mailDownloadLinks) => (
    <Document key={Date.now()}>
        {/* Static pages */}
        <IntroductionPage data={data} confidentialInfo={confidentialInfo} />
        <SalientFactsPage data={data} confidentialInfo={confidentialInfo} />
        <PropertyImagesPage data={data} confidentialInfo={confidentialInfo} />

        {/* Async pages */}
        {await PropertyMailPage(confidentialInfo, mailDownloadLinks)}

        {/* Sales pages */}
        <SalesComparablesPage data={data} confidentialInfo={confidentialInfo} />
        <SalesCompsImagesPage data={data} confidentialInfo={confidentialInfo} />

        {/* Income pages */}
        <MarketCapVacancyRentalRatePage data={data} confidentialInfo={confidentialInfo} />
        <IncomeAndExpenseProFormaPage data={data} confidentialInfo={confidentialInfo} />
        <IncomeCompsImagesPage data={data} confidentialInfo={confidentialInfo} />

        {/* Cost pages */}
        <CostApproachPage data={data} confidentialInfo={confidentialInfo} />
        <CostMVSImagesPage data={data} confidentialInfo={confidentialInfo} />

        {/* Attachments */}
        {await AppealAttachmentsPage(data, confidentialInfo)}
    </Document>
);

export const generatePdf = async (data, mailDownloadLinks) => {
    try {
        const confidentialInfo = getConfidentialInfo(data);
        const pdfDoc = await createPdfDocument(data, confidentialInfo, mailDownloadLinks);
        const blob = await pdf(pdfDoc).toBlob();

        saveAs(blob, createFileName());

        return blob;
    } catch (error) {
        console.error("Error generating PDF:", error);
        throw error;
    }
};
